
import React from "react";
import styled from "styled-components";

const HouseSelectionDiv = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 6px;
    padding: 6px;
    width: 100%;
    box-sizing: border-box;   
    
    justify-content: center;
`;

const HouseButton = styled.button`
    padding: 6px 12px;
    border-radius: 7px;
    border: 1px solid ${({ $selected }) =>
            $selected ? "#019A32" : "#d1d5db"};

    background: ${({ $selected }) =>
            $selected ? "#019A32" : "#ffffff"};

    color: ${({ $selected }) =>
            $selected ? "#ffffff" : "#374151"};

    font-family: "Segoe UI", sans-serif;
    font-size: 13px;
    font-weight: ${({ $selected }) =>
            $selected ? 600 : 400};

    white-space: nowrap;
    cursor: pointer;

    transition: all 0.15s ease;

    &:hover {
        border-color: #019A32;
        background: ${({ $selected }) =>
                $selected ? "#04783a" : "#eefaf1"};
    }

    &:focus-visible {
        outline: 2px solid #019A32;
        outline-offset: 2px;
    }
`;

const HouseSelection = ({
                            houses,
                            selectedHouse,
                            setSelectedHouse
                        }) => {
    return (
        <HouseSelectionDiv>
            {houses.map((house) => (
                <HouseButton
                    key={house}
                    type="button"
                    $selected={selectedHouse === house}
                    aria-pressed={selectedHouse === house}
                    onClick={() => setSelectedHouse(house)}
                >
                    {house}
                </HouseButton>
            ))}
        </HouseSelectionDiv>
    );
};

export default HouseSelection;
